import { OnInit, Input, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-rich-text-area',
  template: '<pre class="my-pre">{{ res }}</pre>',
  styles: [`
        .my-pre {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
            font-size: 100% !important;
        }
    `]
})
export class RichTextAreaComponent implements ViewCell, OnInit {
  // entrada del valor del label
  @Input() value: any;
  // entrada de la fila
  @Input() rowData: any;
  // respuesta
  res = '';

  ngOnInit() {
   if (this.value) {
     this.res = this.value;
   } 
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/component-table/rich-textarea.component.ts